// Per-deployment branding driven by build-time env vars (frontend/.env).
// When unset, everything falls back to the original CNK Group look, so the
// existing cnkgroup.net build is unaffected.

export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || 'CNK Group CRM';

// Applies the document title and optional theme-colour overrides. Only
// variables that are actually set override the defaults defined in App.css.
export function applyBranding() {
  document.title = BRAND_NAME;

  const root = document.documentElement;
  const overrides = {
    '--color-bg-dark': process.env.REACT_APP_NAVBAR_COLOR,
    '--color-primary': process.env.REACT_APP_PRIMARY_COLOR,
    '--color-primary-hover': process.env.REACT_APP_PRIMARY_HOVER_COLOR,
  };

  Object.entries(overrides).forEach(([prop, value]) => {
    if (value) root.style.setProperty(prop, value);
  });
}
